import { connect } from 'react-redux';

import { getProjectsCount } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import RsRootInitializer from './RsRootInitializer';

const mapStateToProps = (state) => ({
  projectsCount: getProjectsCount(state),
});

export default connect(mapStateToProps, null)(RsRootInitializer);
